// imports react
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { urlAPI_Current } from "../config";
import axios from "axios";
import { toast } from "sonner";

export function AdminUser(props) {
  const [isOpen, setIsOpen] = useState(false);

  const navigateTo = useNavigate();
  const menuRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const formatPhoneNumber = (phoneNumber) => {
    const countryCode = phoneNumber.slice(0, 3);
    const areaCode = phoneNumber.slice(3, 5);
    const part1 = phoneNumber.slice(5, 10);
    const part2 = phoneNumber.slice(10);

    return `(${areaCode}) ${part1}-${part2}`;
  };

  const handleDeleteUser = async (userId) => {
    const result = await Swal.fire({
      title: 'Deseja Continuar?',
      text: "Ao excluir esse usuários, todos seus dados serão excluidos, inclusives suas notas, perfis e conversas.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      didOpen: () => {
        const popup = Swal.getPopup();
        if (popup) {
          popup.style.backgroundColor = props.darkMode ? '#212121' : '#f0f0f0';
          const popupText = popup.querySelector('.swal2-title');
        if (popupText) {
          popupText.style.color = props.darkMode ? '#f0f0f0' : '#212121';
        }

        const popupTextContent = popup.querySelector('.swal2-html-container');
        if (popupTextContent) {
          popupTextContent.style.color = props.darkMode ? '#f0f0f0' : '#212121';
        }
        }
      }
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          `${urlAPI_Current}/deleteUser`,
          {
            selectedUserId: userId
          }, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
            }
          }
        );
  
        if(response.data.success){
          toast.success('Usuário deletado com sucesso!')
          props.getAllUsers();
        } else {
          toast.error('Erro ao deletar usuário');
          console.log('Erro ao deletar usuário');
        }
      } catch (error) {
        console.log("Erro ao deletar usuario");
      }
    }
  };

  async function downloadFinalReportPdf(nomeCliente) {
    try {
      toast.info('Iniciando download do relatório...');
  
      const response = await axios.post(
        `${urlAPI_Current}/downloadReportPDFByAdmin`,
        {
          selectedUserId: props.userId
        },
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          },
          responseType: 'blob'
        }
      );
  
      // Cria um link temporário para download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `relatorio-${nomeCliente}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
  
      toast.success('Relatório baixado com sucesso!');
      props.getAllUsers();
  
    } catch (error) {
      console.error('Erro ao baixar o PDF:', error);
      toast.error('Relatório não encontrado. Tente novamente');
    }
  }
  

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    
  }, []);

  function navigateToUserManagement() {
    navigateTo(`/admin/userManagement/${props.userId}`);
  }

    return (
        <tr>
        <td>
          <div className="form-check form-check-sm form-check-custom form-check-solid">
            <input className="form-check-input" type="checkbox" value="1" />
          </div>
        </td>
        <td className="d-flex align-items-center" style={{ borderBottom: 'none' }}>
        <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
          {props.foto ? (
              <img
                  src={`https://evoktm.com.br/evokchat/fotos_usuarios/${props.foto}`}
                  alt="Foto do usuário"
                  onClick={navigateToUserManagement} 
                  style={{ cursor: 'pointer' }}
              />
          ) : (
              <div 
                  className="symbol-label fs-3 bg-primary text-white" 
                  onClick={navigateToUserManagement} 
                  style={{ cursor: 'pointer' }}
              >
                  {props.name ? props.name.slice(0, 2).toUpperCase() : 'N/A'}
            </div>
          )}
        </div>
        <div className="d-flex flex-column">
          <p className="text-gray-800 text-hover-primary mb-1" onClick={navigateToUserManagement} style={{ cursor: "pointer" }}>
            {props.name}
          </p>
          <span>{props.email}</span>
        </div>
      </td>
        <td>{new Date(props.date).toLocaleDateString()}</td>
        <td>
          <div className="badge badge-light fw-bold">{props.age}</div>
        </td>
        <td>{props.phone ? formatPhoneNumber(props.phone) : "Não disponivel"}</td>
        <td>
          <p className="text-gray-800 text-hover-primary mb-1">
            {props.plano == 1 ? 'Evok' : "---"}
          </p>
        </td>

        <td>
            {props.access == 1 ? (
                <div className="badge badge-light-success fw-bold">Sim</div>
            ) : (<div className="badge badge-light-danger fw-bold">Não</div>)}
        </td>

        <td>
          Prompts: {props.prompt_tokens} 
          <br/>
          Resposta:  {props.completion_tokens} 
          <br/>
          Custo: $ {(((props.prompt_tokens / 1000) * 0.00500) + ((props.completion_tokens) / 1000 * 0.01500)).toFixed(3)}
        </td>

        <td className="text-end" style={{ position: 'relative' }}>
          <p onClick={toggleDropdown} className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Ações 
          <i className="ki-outline ki-down fs-5 ms-1"></i></p>
          <div ref={menuRef} className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-200px py-4 ${isOpen ? 'show' : ''}`}
          style={{
            position: 'absolute',
            top: '60%',
            right: '0',
            zIndex: 1001
          }}>
            <div className="menu-item px-3">
              <p className="menu-link px-3" onClick={() => handleDeleteUser(props.userId)}>Deletar Usuário</p>
              {props.codRelatorioFinal ? (
                <p className="menu-link px-3" onClick={() => downloadFinalReportPdf(props.codRelatorioFinal, props.name)}>Baixar Relatátorio</p>
              ) : (null)}
            </div>
          </div>
        </td>

      </tr>
    )
}